import mainBg from "../assests/main-bg.jpg"
import logo from "../assests/logo.svg"
import typ from "../assests/SaintStreamTyp.svg"
import disney from "../assests/disney.png"
import netflix from "../assests/netflix.png"
import hbo from "../assests/hbo.jfif"
import pixar from "../assests/pixar.png"
import marvel from "../assests/marvel.png"
import starwars from "../assests/starwars.png"
import nat from "../assests/nat.png"
import sec from "../assests/sec-bg.jpg"
import listBg from "../assests/list-bg.webp"
import detailBg from "../assests/detail-bg.png"

export default {
    mainBg,
    logo,
    typ,
    disney,
    hbo,
    netflix,
    pixar,
    nat,
    starwars,
    marvel,
    sec,
    listBg,
    detailBg,
}